export default "__VITE_ASSET__lv2qQt_c__"